export default __webpack_public_path__ + "static/media/services_design.18d315c6.svg";